import { Anchor, Button, Modal, Tabs } from "@mantine/core";
import { FeatureFlag } from "../../../components/FeatureFlag/FeatureFlag";
import { Flag } from "../../../hooks/useFeatureFlags.types";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { ExpressOnboardingGeneratorsTable } from "../ExpressOnboardingGeneratorsTable/ExpressOnboardingGeneratorsTable";
import { ExpressOnboardingVollmachtenTable } from "../ExpressOnboardingVollmachtenTable/ExpressOnboardingVollmachtenTable";

export const ERZEUGER_EXPRESS_TABS = {
  GENERAL: "general",
  VOLLMACHT: "vollmachten"
} as const;

export type ExpressOnboardingTab =
  (typeof ERZEUGER_EXPRESS_TABS)[keyof typeof ERZEUGER_EXPRESS_TABS];

export function isExpressOnboardingTab(
  value: string | null
): value is ExpressOnboardingTab {
  return Object.values<string | null>(ERZEUGER_EXPRESS_TABS).includes(value);
}

interface ExpressOnboardingModalProps {
  opened: boolean;
  siteId: number;
  tab: ExpressOnboardingTab;
  onTabChange: (tab: string | null) => void;
  onClose: () => void;
}

function ExpressOnboardingModal({
  opened,
  siteId,
  tab,
  onTabChange,
  onClose
}: ExpressOnboardingModalProps) {
  return (
    <Modal
      closeOnClickOutside={false}
      closeOnEscape={false}
      opened={opened}
      size="90vw"
      title="Erlösmonitoring - Onboarding mehrerer Liegenschaften"
      onClose={onClose}
    >
      <Tabs value={tab} onChange={onTabChange}>
        <Tabs.List mb="md">
          <Tabs.Tab value={ERZEUGER_EXPRESS_TABS.GENERAL}>
            Erzeuger bearbeiten
          </Tabs.Tab>
          <FeatureFlag featureFlag={Flag.showErzeugerExpressVollmachten}>
            <Tabs.Tab value={ERZEUGER_EXPRESS_TABS.VOLLMACHT}>
              Vermarkter-Vollmachten bereitstellen
            </Tabs.Tab>
          </FeatureFlag>
        </Tabs.List>

        <Tabs.Panel value={ERZEUGER_EXPRESS_TABS.GENERAL}>
          <ExpressOnboardingGeneratorsTable siteId={siteId} />
        </Tabs.Panel>
        <FeatureFlag featureFlag={Flag.showErzeugerExpressVollmachten}>
          <Tabs.Panel value={ERZEUGER_EXPRESS_TABS.VOLLMACHT}>
            <ExpressOnboardingVollmachtenTable />
          </Tabs.Panel>
        </FeatureFlag>
      </Tabs>
      <ModalFooter justify="space-between">
        <Anchor component="button" onClick={onClose}>
          Abbrechen
        </Anchor>
        <Button onClick={onClose}>Schließen</Button>
      </ModalFooter>
    </Modal>
  );
}

export { ExpressOnboardingModal };
